<div class="branch-details-container" [formGroup]="formGroup">

  <!-- Branch Information Card -->
  <div class="section-card">

    <div class="container-fluid">

      <div class="row g-3">

        <!-- Branch Name -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">store</mat-icon> -->
            Branch Name
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="branchName" placeholder="Enter Branch Name">
          </mat-form-field>
        </div>

        <!-- Financial Services Director -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">star</mat-icon> -->
            Financial Services Director (FSD)
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="fsd" placeholder="Enter Financial Services Director">
          </mat-form-field>
        </div>

        <!-- Financial Services Manager -->
        <div class="col-md-6">
          <label class="field-label">
            <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
            Financial Services Manager (FSM)
          </label>

          <mat-form-field class="w-100">
            <input matInput formControlName="fsm" placeholder="Enter Financial Services Manager">
          </mat-form-field>
        </div>

      </div>

    </div>

  </div>

</div>

<!-- Form Actions -->
<!-- <div class="form-actions">

  <button mat-raised-button
          class="save-btn"
          (click)="saveAndContinue()"
          [disabled]="formGroup.invalid">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>

</div> -->